import React, { useContext, useEffect, useState } from "react";
import ConfigContext from "../contexts/AppContext";
import styled, { ThemeContext } from "styled-components";
import AppContext from "../contexts/AppContext";
import { createBrowserHistory } from "history";
import LeftBarContext from "../contexts/LeftBarContext";
import appFetch from "../appFetch";
import { appendQueryToUri } from "../util/generalUtil";
import apiEndpoints from "../apiEndpoints";
import icons from "../icons";
import { Menu, Tab, Transition } from "@headlessui/react";
import { Fragment } from "react";
import classNames from "classnames";
import BannerModal from "./BannerModal";
import BannerModal2 from "./BannerModal2";

const Icon = styled.div`
  width: 33px;
  height: 33px;
  background: ${({ theme, read }) => theme?.colors.accent};
  color: ${({ theme, read }) => theme?.colors.primary};
  /* border: 1px solid #ffdede; */
  box-sizing: border-box;
  border-radius: 5px;
`;

const NotificationItem = styled.li`
  background: ${({ theme, read }) => (read ? theme?.colors.accent : "inherit")};
  border-bottom: 1px solid #f3f3f3;
  padding-bottom: 10px;
`;

const TabHead = styled.div`
  box-shadow: 0px 1px 2px rgb(0 0 0 / 15%);
`;

const Badge = styled.span`
  width: 18px;
  height: 18px;
  font-size: 0.7em;
  color: ${({ theme, active }) =>
    active ? theme?.colors?.primary : "#BBBBBB"};
  background: ${({ theme, active }) =>
    active ? theme?.colors.accent : "#F3F3F3"};
`;

const Dialog = styled.div`
  width: ${({ type }) =>
    ["Notifications", "Profile"].includes(type) ? "368px" : "auto"};
`;

const iconMap = {
  home: "HomeIcon",
  setup: "SetupIcon",
  transaction: "TransactionIcon",
  approval: "ApprovalIcon",
  memo: "MemoIcon",
  open: "OpenIcon",
  dashboard: "DashboardIcon",
  confirmation: "ConfirmationIcon",
  payrollReports: "PayrollReportsIcon",
  otherReports: "OtherReportsIcon",
  essReports: "EssReportsIcon",
  bioData: "BioDataIcon",
  Online: "OnlineIcon",
  Users: "UsersIcon",
  Retail: "RetailIcon",
  Wallet: "WalletIcon",
  Ussd: "UssdIcon",
  Draws: "DrawsIcon",
  ThirdParty: "ThirdPartyIcon",
  Accuracy: "AccuracyIcon",
  Feeds: "FeedsIcon",
  Whatsapp: "WhatsappIcon",
  Error: "ErrorIcon",
  Calender: "CalenderIcon",
  map: "MapIcon",
  Statistics: "StatisticsIcon",
  OtherReports: "OtherReportsIcon",
  Ticket: "TicketIcon",
  Search: "SearchIcon",
  report: "OtherReportsIcon",
  Forms: "FormsIcon",
  module: "FormsIcon",
  reports: "StatisticsIcon",
  money: "MoneyIcon",
  action: "ActionIcon",
  followup: "FollowUpIcon",
  pending: "PendingIcon",
  qualified: "PassIcon",
  schedule: "ScheduledIcon",
  demo: "DemoIcon",
  proposal: "PlanIcon",
  onboarding: "OnboardIcon",
  crm: "CRMIcon",
  sales: "SalesIcon",
  inventory: "InventoryIcon",
  horizontalbarchart: "HorizontalBarIcon",
  verticalbarchart: "VerticalBarIcon",
  scatterchart: "ScatterIcon",
  layout: "LayoutIcon",
  piechart: "PieIcon",
  linechart: "LineIcon",
  "": "setup",
};

const Dropdown = ({
  key,
  name,
  icon,
  active,
  type,
  options,
  setLoading,
  openNewPage,
  activeMenu,
}) => {
  const theme = useContext(ThemeContext);
  const buttonRef = React.useRef(null);
  const [alignment, setAlignment] = useState("center");

  const handleOpen = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const screenWidth = window.innerWidth;

      if (rect.left < 180) {
        setAlignment("left");
      } else if (screenWidth - rect.right < 180) {
        setAlignment("right");
      } else {
        setAlignment("center");
      }
    }
  };

  return (
    <div key={name} className="relative inline-block">
      <Menu as="div">
        <Menu.Button
          ref={buttonRef}
          onClick={handleOpen}
          className="inline-flex items-center gap-1 lg:gap-2 lg:px-3 lg:py-2 p-1 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors"
        >
          <span className="hidden lg:flex text-sm text-gray-700">{name}</span>
          {React.createElement(icon, {
            width: 20,
            height: null,
            fill: active ? theme?.colors?.primary : "#AAAAAA",
            stroke: active ? theme?.colors?.primary : "#AAAAAA",
          })}
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-150"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <Menu.Items
            as={Dialog}
            type={type}
            className={classNames(
              "absolute mt-2 w-[250px] lg:w-[368px] z-50 rounded-lg shadow-xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none",
              {
                "left-0": alignment === "left",
                "right-0": alignment === "right",
                "left-1/2 -translate-x-1/2": alignment === "center",
              }
            )}
          >
            <BannerModal2
              options={options}
              setLoading={setLoading}
              openNewPage={openNewPage}
              activeMenu={activeMenu}
            />
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

function BannerArea1({ name, options, type, setLoading }) {
  const [activeItem, setActiveItem] = useState();

  const { config, setConfig } = useContext(ConfigContext);
  const theme = useContext(ThemeContext);
  const { context, setContext } = useContext(AppContext);
  const { menuCollapse, setMobileMenuOpen } = useContext(LeftBarContext);
  // const history = useHistory();
  const history = createBrowserHistory();
  const {
    location: { pathname },
  } = history;

  let _pathname = pathname.split("/").slice(-1)[0]?.toLowerCase() || "home";
  _pathname = decodeURI(_pathname.replace(/\//, "")).replace(/\-/g, " ");
  let patt = RegExp(_pathname, "i");
  console.log("patt", patt);
  let activeMenu = options?.find((menu) => patt.test(menu?.name));
  let { targetid: menuId } = activeMenu || {};

  const currentPath = pathname.split("/").slice(-1)[0]?.toLowerCase() || "home";

  useEffect(() => {
    setContext((prev) => ({ ...prev, menuId }));
  }, [pathname]);

  console.log("contextData", context);

  console.log("initial options", options);
  let groupedOrder = {};
  let optionsGroup = [];
  let optionsGroupLen = -1;

  options.forEach((o) => {
    if (o.group) {
      const groupKey = o.group.trim(); // normalization, optionally use toLowerCase()

      if (!(groupKey in groupedOrder)) {
        groupedOrder[groupKey] = ++optionsGroupLen;
      }

      const index = groupedOrder[groupKey];

      if (!optionsGroup[index]) {
        optionsGroup[index] = {
          name: groupKey,
          icon: o.groupicon,
          options: [o],
        };
      } else {
        optionsGroup[index].options.push(o);
      }
    } else {
      optionsGroup[++optionsGroupLen] = o;
    }
  });

  console.log("banner optionsGroup", optionsGroup);

  const loadPage = (item) => {
    setLoading(true);

    let postData = {
      urlMenu: null,
      layoutId: null,
      targetId: item.targetid,
      target: "MENU",
      schemaId: null,
      txnGroup: null,
      parentDropValue: null,
    };

    appFetch
      .get(appendQueryToUri(apiEndpoints.menuView, postData))
      .then((res) => {
        let link = `${item.name.toLowerCase()}`;
        history.push(link.replace(/\s/g, "-"));
        // setContextMenuId(menuId)
        console.log("the response for loadpage", res);
        let page = { ...context.pageConfig };
        let [leftArea, MainArea, rightArea] = page.subcomponents;
        page.subcomponents = [leftArea, res, rightArea];

        setContext((prev) => ({
          ...prev,
          menuId: item.targetid,
          pageConfig: page,
        }));
      })
      .catch((e) => console.log(e.message))
      .finally(() => setLoading(false));
  };

  const openNewPage = (item) => {
    // setMobileMenuOpen(true);
    console.log(
      "the open new page function",
      item.name.toLowerCase(),
      activeMenu?.name.toLowerCase()
    );
    if (item.name.toLowerCase() === activeMenu?.name.toLowerCase()) return;
    loadPage(item);
  };

  return (
    <>
      <div>
        {/* <label
          className={`text-sm md:text-base font-bold uppercase inline-block text-custom-gray-400`}
          htmlFor={name}
        >
          Menu
        </label> */}
      </div>
      <div className="grid grid-flow-col gap-2 lg:gap-4 z-10 bg-gray-50 px-2 py-2 shadow-md item-center justify-items-center">
        {optionsGroup &&
          optionsGroup.map(({ name, icon, options }, idx) => {
            const patt = new RegExp(`^${name}$`, "i");
            const active = patt.test(activeMenu?.name);

            return (
              name && (
                <Dropdown
                  key={idx}
                  name={name}
                  type={type}
                  icon={icons[iconMap[icon]]}
                  active={active}
                  options={options}
                  setLoading={setLoading}
                  openNewPage={openNewPage}
                  activeMenu={activeMenu}
                />
              )
            );
          })}
      </div>
    </>
  );
}

export default BannerArea1;
